export const stickyHeader = (() => {
	const distance = 50;
	const header = document.querySelector(".header");

	const onScroll = () => {
		header.classList.toggle("is-scrolled", window.scrollY > distance);
	};

	const init = () => {
		window.addEventListener("scroll", onScroll);
	};

	return {
		init: init,
	};
})();
